export default "__VITE_ASSET__BUua4EHH__"